import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import get from 'lodash/fp/get'
import getOr from 'lodash/fp/getOr'
import logo from 'assets/logo.svg'
import useAuth from 'utils/authHook'
import Section from 'components/ui/Section'

const Login = () => {
  const { login, autoLogin, error, fetching } = useAuth()
  const username = useRef()
  const password = useRef()
  const history = useHistory()
  const redirectTo = getOr('/kids', 'location.state.from.pathname', history)

  useEffect(() => {
    if (localStorage.getItem('token')) autoLogin({ redirectTo })
    // eslint-disable-next-line
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()

    login({
      username: get('current.value', username),
      password: get('current.value', password),
      redirectTo,
    })
  }

  if (fetching) {
    // TODO: show spinner on login form
  }

  return (
    <Section>
      <div style={{ marginTop: '10vh' }}>
        <div className="flex justify-center">
          <img src={logo} alt="Taskly Logo" />
        </div>
        <div className="max-w-xs m-auto mt-2">
          <h2 className="w-full mb-12 text-2xl font-hairline tracking-wide text-center text-gray-500">
            A family chore and task app.
          </h2>
          <form onSubmit={onSubmit}>
            <input
              ref={username}
              type="text"
              name="username"
              placeholder="Username"
              className="w-full p-2 mb-4 rounded shadow-sm"
              autoFocus={true}
            />
            <input
              ref={password}
              type="password"
              name="password"
              placeholder="Password"
              className="w-full p-2 mb-8 rounded shadow-sm"
            />
            {error && <span>{error}</span>}
            <button
              type="submit"
              className="w-full p-2 mb-2 font-medium tracking-wider text-white bg-pink-400 rounded focus:bg-green-400"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </Section>
  )
}

export default Login
